<div class="container-fluid card p-3 mt-3" *ngIf="!isLoading && induction">
  <h2 class="mb-3 text-primary">Education Induction Details</h2>

  <div class="card p-3 mb-3 border">
    <h4 class="text-primary">Induction Details</h4>

    <table class="table table-bordered">
      <tbody>
      <tr>
        <th>Induction For</th>
        <td>{{ induction.inductionFor || 'NA'}}</td>
      </tr>
      <tr>
        <th>Induction Centre</th>
        <td>{{ induction?.inductionCentreName }}</td>
      </tr>

      <tr>
        <th width="30%">Submitted Date</th>
        <td>{{ induction?.createdAt?.toDate() | date:'dd MMM yyyy, hh:mm a' }}</td>
      </tr>

      <tr *ngIf="induction?.updatedAt">
        <th width="30%">Last Updated Date</th>
        <td>{{ induction?.updatedAt?.toDate() | date:'dd MMM yyyy, hh:mm a' }}</td>
      </tr>

<!--      <tr>-->
<!--        <th width="30%">Status</th>-->
<!--        <td>-->
<!--            <span class="badge" [ngClass]="induction.status === 'Active' ? 'bg-success' : 'bg-danger'">-->
<!--              {{ induction.status }}-->
<!--            </span>-->
<!--        </td>-->
<!--      </tr>-->
      </tbody>
    </table>
  </div>

  <!-- Days Table -->
  <div class="card p-3 mb-3 border" *ngIf="induction?.days && induction.days.length > 0">
    <h4 class="text-primary mb-3">Induction Days</h4>

    <div class="table-responsive">
      <table class="table table-bordered table-striped text-center">
        <thead class="table-primary">
        <tr>
          <th style="width: 6%">Day</th>
          <th style="width: 12%">Date</th>
          <th style="width: 15%">Teacher</th>
          <th style="width: 15%">Centre</th>
          <th style="width: 18%">Topic</th>
          <th style="width: 20%">Content</th>
          <th style="width: 10%">Suggestions</th>
          <th style="width: 8%">Status</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let day of induction.days; let i = index">

          <td>
            <strong>Day {{ i + 1 }}</strong>
          </td>

          <td>
            {{ day?.date?.toDate() | date:'dd MMM yyyy' }}
          </td>
          <!-- Teacher -->
          <td>
            {{ day?.teacherName || induction?.teacherName || 'NA' }}
          </td>
          <!-- Centre -->
          <td>
            {{ day?.centreName || induction?.centreName || 'NA' }}
            <span *ngIf="day?.centreCode || induction?.centreCode">
      ({{ day?.centreCode || induction?.centreCode }})
    </span>
          </td>



          <!-- Topic -->
          <td>
    <span *ngIf="!expandedFields['topic_' + i]">
      {{ getTruncatedText(day?.topic, 50) }}
    </span>

            <span *ngIf="expandedFields['topic_' + i]">
      {{ day?.topic }}
    </span>

            <button
              *ngIf="shouldShowMoreButton(day?.topic, 50)"
              mat-button
              color="primary"
              (click)="toggleExpanded('topic_' + i)"
              class="p-0 ms-2"
              style="min-width:auto;font-size:12px;">
              {{ expandedFields['topic_' + i] ? 'Show Less' : 'Show More' }}
            </button>
          </td>

          <!-- Content -->
          <td>
    <span *ngIf="!expandedFields['content_' + i]">
      {{ getTruncatedText(day?.content, 60) }}
    </span>

            <span *ngIf="expandedFields['content_' + i]">
      {{ day?.content }}
    </span>

            <button
              *ngIf="shouldShowMoreButton(day?.content, 60)"
              mat-button
              color="primary"
              (click)="toggleExpanded('content_' + i)"
              class="p-0 ms-2"
              style="min-width:auto;font-size:12px;">
              {{ expandedFields['content_' + i] ? 'Show Less' : 'Show More' }}
            </button>
          </td>

          <!-- Suggestions -->
          <td>
            {{ day?.suggestions || 'NA' }}
          </td>

          <!-- Status -->
          <td>
            <mat-chip [ngClass]="{
      'bg-success text-white': day.status === 'Done',
      'bg-warning text-dark': day.status === 'Pending'
    }">
              {{ day.status || 'Pending' }}
            </mat-chip>
          </td>

        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row justify-content-center d-flex mt-3">
    <div class="col-md-4">
      <button mat-raised-button color="warn" routerLink="/home/education/induction-list">
        Back to List
      </button>
    </div>
  </div>
</div>

<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
